exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2SJX4i181z_110{padding:0;max-width:582px;min-width:532px}@media only screen and (max-width:750px){._2SJX4i181z_110{max-width:none;min-width:0;width:100%;border:0;display:flex;flex-direction:column;flex-grow:1}}", ""]);

// exports
exports.locals = {
	"upperBox": "_2SJX4i181z_110"
};